
export default function PointLight(props) {

    return (

        <mesh
            position = {[props.data.pointX, props.data.pointY, props.data.pointZ]}
        >


            <pointLight

                color  = {props.data.pointColor}
                intensity = {props.data.pointIntensity}
                distance={props.data.pointDistance}
            /> 

        </mesh>

        

    )
}
